@if (!editMode) {
    <div class="worksheet-item">
        <div (click)="openWorksheet()"
             (keydown.enter)="openWorksheet()"
             (keydown.space)="$event.preventDefault(); openWorksheet()"
            class="worksheet-content"
             tabindex="0"
             role="button"
        >
            <span class="worksheet-title">{{ title }}</span><br>
            @if (null !== belongsTo) {
                <span class="worksheet-belongs-to">zu: "{{ belongsTo }}"</span>
            }
        </div>

        <div class="dropdown-element">
            <div class="dropdown">
                <button
                    class="btn btn-blue p-0 border-0 dropdown-toggle"
                    data-bs-toggle="dropdown"
                    data-bs-offset="20, 5"
                    type="button"
                >
                    <i class="fas fa-angle-down statistic"></i>
                </button>
                <ul class="dropdown-menu">
                    <li class="dropdown-item">
                        <button (click)="openWorksheet()">
                            <i class="far fa-edit"></i>Im Editor bearbeiten
                        </button>
                    </li>
                    <li class="big-divider"></li>
                    <li class="dropdown-item">
                        <button (click)="toggleEditMode()">
                            <i class="far fa-pencil"></i>Umbenennen
                        </button>
                    </li>
                    <li><hr class="dropdown-divider"></li>
                    <li class="dropdown-item red">
                        <button (click)="deleteWorksheet()">
                            <i class="fas fa-times"></i>Aus Liste entfernen
                        </button>
                    </li>
                </ul>
            </div>
        </div>
    </div>
}

@if (editMode) {
    <div class="worksheet-form">
        <label [for]="'#text-input' + worksheet.id">
            Titel des Arbeitsblatts:
        </label>
        <textarea [id]="'text-input' + worksheet.id" [(ngModel)]="title" rows="2"></textarea>
        @if (null !== belongsTo) {
            <span class="worksheet-belongs-to">zu: "{{ belongsTo }}"</span>
        }
        <div class="worksheet-edit-buttons">
            <button (click)="editWorksheet()"
               class="save btn btn-round btn-semibold"
            > Speichern</button>
            <button (click)="toggleEditMode()"
               class="cancel"
            >Abbrechen</button>
        </div>
    </div>
}